"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var yotpo_1 = require("../../utils/yotpo");
var YotpoStar_1 = require("../Yotpo/YotpoStar");
var ShopContext_1 = require("./ShopContext");
var color_1 = require("../common/color");
var ShopYotpoReviews = function () {
    var _a = (0, hooks_1.useContext)(ShopContext_1.default), colors = _a.colors, shopData = _a.shopData;
    var _b = (0, hooks_1.useState)(null), reviewData = _b[0], setReviewData = _b[1];
    (0, hooks_1.useEffect)(function () {
        var query = { page: 1 };
        var productId = shopData.defaultProduct.reference.id.split('/')[4];
        (0, yotpo_1.getReviewData)(+productId, query)
            .then(function (res) {
            setReviewData(res);
        })
            .catch(function (err) { return console.error(err); });
        // logic so that review count in shop section links to review module if available
        window.addEventListener('load', function () {
            var yotpoReviewsModule = document.getElementById('anchor--yotpo-review');
            var yotpoReviewsLink = document.querySelector('.shop-v2-yotpo__clickable');
            if (yotpoReviewsModule && yotpoReviewsLink) {
                yotpoReviewsLink.setAttribute('href', '#anchor--yotpo-review');
            }
        });
    }, []);
    // don't display yotpo review rating and count if no reviews
    if (!reviewData || reviewData.bottomline.total_review === 0) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var avgScore = +Number(reviewData.bottomline.average_score).toFixed(1);
    return ((0, preact_1.h)("div", { class: "shop-v2-yotpo__bottomline" },
        (0, preact_1.h)("div", { class: "shop-v2-yotpo__stars" },
            (0, preact_1.h)(YotpoStar_1.default, { score: avgScore, size: "large", id: "shop-v2-yotpo-review-bottomline-star", color: (0, color_1.toHex)(colors.yotpoStars) || '#faa943' }),
            (0, preact_1.h)("a", { class: "shop-v2-yotpo__clickable" },
                (0, preact_1.h)("p", { class: "shop-v2-yotpo__review-count" },
                    reviewData.bottomline.total_review,
                    " Reviews")))));
};
exports.default = ShopYotpoReviews;
